import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';

const styles = (theme) => ({
  root: {},
  fields: {
    padding: theme.spacing(0),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    loadModalCollectionByLink,
    clearModalCollection,
  } = useModalContext();

  const { refreshPageContentCollection } = usePageContentContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <TitleSection />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={async () => {
          const resp = await onSubmit();
          if (resp) {
            clearModalCollection();
            refreshPageContentCollection();
          }
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
      {resource.meta().action('DELETE') ? <WizardStepDeleteButton
        className={classes.deleteButton}
        onDelete={handleDelete}
        onDeleteSuccess={onDeleteSuccess}
        dialogProps={{
          title: 'Are you sure?',
          message: 'Removing this item will delete all of its information. This cannot be undone.',
          cancelLabel: 'Nevermind',
          confirmLabel: 'Remove',
        }}
      /> : null}
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
